const TermsService = {
  'pages_terms_TermsService.1': '서비스 약관',

}

export default TermsService



// WEBPACK FOOTER //
// ./src/lang/terms/TermsService.kr.js